<template>
  <main id="shipment-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('customerService.shipment.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="7" class="default-section-title">
              {{ $t('customerService.shipment.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="10"  class="default-section-title totals-section">
               <el-row class="default-section-header">
                  <el-col :span="9" v-if="shipment.total > 0" class="default-section-title shipment-total total-amount">
                    <template >
                      {{ `${$t('customerService.shipment.totalAmount')}: ${getTotalAmount(shipment)}` }}
                    </template>
                  </el-col>
                  <el-col :span="7" v-if="shipment.total > 0" class="default-section-title shipment-total">
                    <template>
                      {{ `${$t('customerService.shipment.totalUnits')}: ${shipment.totalUnits}` }}
                    </template>
                  </el-col>
                  <el-col :span="8" v-if="shipment.total > 0" class="default-section-title shipment-total">
                    <template>
                      {{ `${$t('customerService.shipment.totalCubes')}: ${shipment.totalCubes}` }}
                    </template>
                  </el-col>
               </el-row>
            </el-col>
            <el-col :span="7" class="default-section-actions text-align-end">
              <closing-actions />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import ClosingActions from './components/ClosingActions';

export default {
  name: 'shipment',
  components: {
    ClosingActions,
    SearchFilter,
    SearchSummary,
  },
  computed: {
    ...mapGetters(['shipment'])
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    },
    getTotalAmount(shipment) {
      const total = shipment.totalAmount;
      if (total < 0) {
        return `(${this.$options.filters.currency(total).replace('-', '')})`;
      }
      return this.$options.filters.currency(total);
    }

  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  #shipment-main {
    .shipment-total {
      font-size: 13px !important;
    }
    .total-amount {
      padding-left: 0px !important;
    }
    .totals-section {
      padding-left: 5px !important;
    }
  }
</style>
